// @flow
import React from 'react';
import range from 'lodash/range';

import RouteStopWeekSchedule from './routeStopWeekSchedule';
import WeekHeader from './weekHeader';
import RouteStop, { SelectPlaceHolder } from './routeStop';
import * as styles from './scheduleTable.css';


type ScheduleTablePropTypes = {
  value: Object,
  onChange: Function,
  title: String,
} ;

const ScheduleTable = ({
  value,
  onChange,
  title = '',
}: ScheduleTablePropTypes) => {
  const vIds = Object.keys(value);

  return (
    <table className={styles.calendarTable}>
      <tbody>
        <WeekHeader title={title} />
        {
          vIds.length === 0 && (
            <tr>
              <SelectPlaceHolder />
              <RouteStopWeekSchedule
                value={undefined}
                occupiedDays={[]}
                routeWeekDays={[]}
                onChange={() => {}}
              />
            </tr>
          )
        }
        {
          (vIds.length > 0) && vIds.map(vId => (
            <tr key={vId}>
              <RouteStop
                name={value[vId].name}
                route={value[vId].routeName}
                onClick={() => {
                  const nValue = { ...value };
                  delete nValue[vId];
                  onChange(nValue);
                }}
              />
              <RouteStopWeekSchedule
                value={value[vId] ? value[vId].week_days : undefined}
                occupiedDays={[]}
                routeWeekDays={value[vId].route_week_days}
                onChange={(weekSchedule, added, day) => {
                  const nValue = { ...value };

                  if (added) {
                    vIds.filter(stopId => stopId != vId).forEach(
                      (stopId) => {
                        if ((value[stopId].week_days || []).includes(day)) {
                          nValue[stopId] = {
                            ...nValue[stopId],
                            week_days: (value[stopId].week_days || []).filter(lDay => lDay != day),
                          };
                        } else {
                          nValue[stopId] = { ...value[stopId] };
                        }
                      },
                    );
                  }

                  onChange({
                    ...nValue,
                    [vId]: {
                      ...nValue[vId],
                      week_days: [ ...weekSchedule ],
                    }
                  });
                }}
              />
            </tr>
          ))
        }
      </tbody>
    </table>
  )
};

export default ScheduleTable;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentStopsScheduling/ScheduleTable/index.jsx